import React, { useState, useEffect, useCallback } from "react";
import { useParams, Navigate } from "react-router-dom";
import { getStore } from "@/api/settings";
import LeftNav from "./LeftNav";
import Settings from "./Settings";

const VALID_TABS = [
  "ingestion-history",
  "pos",
  "categories-mapping",
  "product-mapping",
  "rules",
];

const SettingsPage = () => {
  const { tab } = useParams();
  const selected = tab && VALID_TABS.includes(tab) ? tab : "ingestion-history";
  const [hasPosConnection, setHasPosConnection] = useState(false);
  const [posCheckLoading, setPosCheckLoading] = useState(true);

  useEffect(() => {
    const check = async () => {
      try {
        const res = await getStore();
        setHasPosConnection(!!res?.store?.api_credentials?.provider);
      } catch {
        setHasPosConnection(false);
      } finally {
        setPosCheckLoading(false);
      }
    };
    check();
  }, [tab]);

  const handlePosConnectionChange = useCallback((isConnected) => {
    setHasPosConnection(Boolean(isConnected));
  }, []);

  // Redirect /external-feeds (no tab) to ingestion-history
  if (!tab) {
    return <Navigate to="/external-feeds/ingestion-history" replace />;
  }

  if (!VALID_TABS.includes(tab)) {
    return <Navigate to="/external-feeds/ingestion-history" replace />;
  }

  return (
    <div>
      <div className="flex min-h-screen bg-slate-50 dark:bg-slate-900">
        <LeftNav
          selected={selected}
          hasPosConnection={hasPosConnection}
          posCheckLoading={posCheckLoading}
        />
        <Settings
          selected={selected}
          hasPosConnection={hasPosConnection}
          posCheckLoading={posCheckLoading}
          onPosConnectionChange={handlePosConnectionChange}
        />
      </div>
    </div>
  );
};

export default SettingsPage;
